import { doPostFetch } from "./apiFetchHelper";

export default {
  getProgram: () => {
    let url = "/api/program";
    return doPostFetch(url, {});
  },
};
